import { useEffect } from "react";

export function useScrollLock(lock = true) {
  useEffect(() => {
    if (lock) {
      document.body.classList.add("overflow-hidden");
      return () => {
        document.body.classList.remove("overflow-hidden");
      };
    }
  }, [lock]);
}